'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var button = document.querySelector('.product-related .product-related-save');
    if (button) {
        button.addEventListener('click', saveButtonClick);
    }
    var deleteFileButtons = document.querySelectorAll('.product-file-delete-button');
    registerDeleteActions(deleteFileButtons);

    enableMedia(window.location.hash);

    function registerDeleteActions(deleteFileButtons) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            var _loop = function _loop() {
                var deleteButton = _step.value;

                deleteButton.addEventListener('click', function () {
                    var url = '/Upload/DeleteProductCustomFile/' + deleteButton.dataset.customFileId;
                    var xhr = new XMLHttpRequest();
                    xhr.open("DELETE", url, true);
                    xhr.setRequestHeader('X-XSRF-TOKEN', getCookie('XSRF-TOKEN'));
                    xhr.onload = function () {
                        deleteCustomFileComplete(xhr);
                    };
                    xhr.send();
                });
            };

            for (var _iterator = deleteFileButtons[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                _loop();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }

    function deleteCustomFileComplete(xhr) {
        try {
            var response = JSON.parse(xhr.response);
            if (response.result.success) {
                _notify2.default.success(response.result.message);
                window.location.hash = '#media';
                window.location.reload();
            } else {
                writeError(response.detail, response.message, response.message);
            }
        } catch (exception) {
            writeError(exception);
        }
    }

    function enableMedia(hash) {
        if ((hash = (hash || '').toLowerCase()) === '#media') {
            var link = document.querySelector('a[href=\'' + hash + '\']');
            if (!link) return;
            link.click();
        }
    }

    function saveButtonClick() {
        try {
            var dropZone = (document.querySelector('.dz-started') || {}).dropzone;
            if (!dropZone) return;

            var guidArray = [];
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = dropZone.files[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var file = _step2.value;

                    guidArray.push({ Guid: file.guid });
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            sendData(guidArray);
        } catch (exception) {
            writeError(exception);
        }
    }

    function sendData(requestObject) {
        var url = '/Upload/AssignUploadedAttachments';
        var xhr = new XMLHttpRequest();
        xhr.open("POST", url, true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.setRequestHeader('X-XSRF-TOKEN', getCookie('XSRF-TOKEN'));
        xhr.onload = function () {
            sendDataComplete(xhr);
        };
        var prodId = parseInt(window.location.pathname.split('/').pop());

        xhr.send(JSON.stringify({ dropZoneIdentifiers: requestObject, productId: prodId }));
    }

    function sendDataComplete(xhr) {
        try {
            var response = JSON.parse(xhr.response);
            if (response.result.success) {
                _notify2.default.success(response.result.message);
                $('#uploadProductFiles').modal('hide');
                window.location.hash = '#media';
                window.location.reload();
            } else {
                writeError(response.detail, response.message, response.message);
            }
        } catch (exception) {
            writeError(exception);
        }
    }

    function writeError(exception, errorMessage, userMessage) {
        _notify2.default.error(userMessage || Resx.Common.Error);
        console.error(exception, errorMessage);
    }
};

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/Initializers/fileDownloads.js
// module id = 406
// module chunks = 0